import { render, staticRenderFns } from "./ClientServiceLinkDialog.vue?vue&type=template&id=899c3bda&"
import script from "./ClientServiceLinkDialog.vue?vue&type=script&lang=js&"
export * from "./ClientServiceLinkDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports